import axios from "axios";
import { MasterDataURL } from "../../../../config/UrlEndPoint";

export const URL = `${MasterDataURL}benefis_category`;

// Get BenefisCategory All For use Combobox data
export function getBenefisCategoryAll(queryParams) {
  return axios.get(URL, { params: queryParams });
}

export function getBenefisCategoryAllNotFiltered() {
  return axios.get(`${URL}/not_filtered`);
}

// Get BenefisCategory All For use Combobox data
export function getBenefisCategoryAllCompany() {
  return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getBenefisCategoryById(benefisCategoryId) {
  return axios.get(`${URL}/${benefisCategoryId}`);
}

// items => filtered/sorted result for table data
export function findBenefisCategory(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the benefisCategory on the server
export function createBenefisCategory(benefisCategory) {
  return axios.post(URL, benefisCategory);
}

// UPDATE => PUT: update the benefisCategory on the server
export function updateBenefisCategory(benefisCategory) {
  return axios.put(`${URL}/${benefisCategory.uuid}`, benefisCategory);
}

export function deleteBenefisCategory(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}
